import { render, staticRenderFns } from "./MySingleOrder.vue?vue&type=template&id=1a6245d1&"
import script from "./MySingleOrder.vue?vue&type=script&lang=js&"
export * from "./MySingleOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports